import Marquee from "react-fast-marquee";
import { DESTINATIONS } from "@/data/site";
import { tr } from "@/i18n";

export default function EditorialMarquee({ className = "" }) {
  return (
    <div data-testid="destinations-marquee" className={`py-10 border-y border-white/10 overflow-hidden ${className}`}>
      <Marquee speed={28} gradient={false} pauseOnHover>
        {DESTINATIONS.map((d) => (
          <span key={d} className="flex items-center">
            <span className="font-serif italic font-light text-2xl md:text-3xl text-white/25 px-8 whitespace-nowrap">
              {tr(d)}
            </span>
            <span className="w-1.5 h-1.5 rotate-45 bg-gold/40" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
